import moment from "moment";
import React, { Component, useEffect, useRef, useState } from "react";
// import { connect } from 'react-redux';
// import { getConsoleUserLoginHistory } from '../../actions/userLogActions';
import { Form, Col, Row, Button, Table } from "react-bootstrap";
import { Redirect } from "react-router";
import { withRouter } from "react-router-dom";
// import Moment from 'react-moment';
// import { getConsoleUserByNameOrNumber } from '../../actions/userLogActions';
// import Pagination from '../subLevel/Pagination';

import "../../assets/styles/RetailPortalCouponsList.css";
import { get, post, sess_get, sess_post } from "../../utils/HttpRequests";
import AddNumberCSVModal from "../modals/AddNumberCSVModal";
import { CSVLink } from 'react-csv';

export default function CouponUserList(props) {
  const csvLink = useRef(null);
  const [users, setUsers] = useState([]);
  const [fetching, setFetching] = useState(false);




  const initiate = async () => {
    const { id } = props.match.params;
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    setFetching(true);
    await sess_get(`admin/console/discount-coupon-users-list/?coupon=${id}`, session_token)
      .then((response) => {
        const result = response?.data?.response;
        setUsers(result);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  }

  useEffect(() => {
    initiate();
  }, []);




  return (
    <div className="retail-store-list-container">
      <div className="table-header">
        <div>Coupon Users</div>
        <CSVLink
          data={users.map((item, index) => ({
            'Sr. No.': index + 1,
            'User ID': item?.user_id || '-',
            'Platform': item?.source || '-',
            'Date': item?.created_at ? moment(item?.created_at).format('DD-MM-YYYY') : '-'
          }))}
          filename={`users_availed_discount_${props.match.params.id}.csv`}
          ref={csvLink}

        />
        <div>
          {
            users.length > 0 &&
            <button
              style={{ marginRight: '16px' }}
              onClick={() => { csvLink.current.link.click() }}
            >Download List</button>
          }
          <button
            onClick={() => {
              const { history } = props;
              const path = `/discount-coupon`;
              history.push(path);
            }}
          >
            Back
          </button>
        </div>
      </div>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>User ID</th>
            <th>Platform</th>
            <th>Date</th>

          </tr>
        </thead>
        <tbody>
          {users.length > 0 && users.map((item, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item?.user_id || '-'}</td>
                <td>{item?.source || '-'}</td>
                <td>{item?.created_at ? moment(item?.created_at).format('DD-MM-YYYY') : '-'}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {!fetching && users.length === 0 && <h4 style={{ textAlign: 'center' }}>No User found</h4>}
    </div >
  );
}

